<rotec-modal-v2 [title]="'modalCancelReportTemplateTitle'" [darkMode]="true">
  <ng-container ngProjectAs="modal-main">
    <h2 translate>modalCancelReportTemplateText</h2>
    <p translate>modalCancelReportTemplateCaption</p>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button dark rotec-button-secondary (click)="abort()">
      {{ 'modalCancelReportTemplateBtnNo' | translate }}
    </button>
    <button dark rotec-button-active (click)="ok()">
      {{ 'modalCancelReportTemplateBtnYes' | translate }}
    </button>
  </ng-container>
</rotec-modal-v2>
